import { create, useStore } from 'zustand';

/**
 * 考虑到后面各种单独的模态框越来越多，而且模态框的状态比较简单，只是一个简单的开关。
 * 所以这里尝试用一个统一的store来管理所有的模态框，而不用每个都单独创建一个store, hook了。
 */

interface ModalsState {
  subscriptionModalOpened: boolean;
  paymentSuccessModalOpened: boolean;
  // ... 其他模态框
}
const createModalsStore = () =>
  create<ModalsState>(() => ({
    subscriptionModalOpened: false,
    paymentSuccessModalOpened: false,
  }));
const modalsStore = createModalsStore();

export const Modals = {
  toggle: (modalName: keyof ModalsState, opened: boolean) => modalsStore.setState({ [modalName]: opened }),
};

export const useModals = () => {
  const store = useStore(modalsStore);

  return {
    subscriptionModalOpened: store.subscriptionModalOpened,
    paymentSuccessModalOpened: store.paymentSuccessModalOpened,
    toggle: Modals.toggle,
  };
};
